import React, { useState } from 'react';
import { FaShare } from 'react-icons/fa';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';
import { ReactComponent as CloseIcon } from '../../../../shared/assets/svgs/CloseIcon.svg';
import { ReactComponent as GreenOrderIcon } from '../../../../shared/assets/svgs/GreenOrderIcon.svg';

interface ShareButtonProps {
    onShare: () => Promise<void>;
    disabled?: boolean;
    hasShared?: boolean;
    dialogTitle?: string;
    loading?: boolean;
    dialogDescription?: string;
}

export const ShareButton: React.FC<ShareButtonProps> = ({
    onShare,
    disabled = false,
    hasShared = false,
    loading = false,
    dialogTitle = 'Order Execution',
    dialogDescription = 'Are you sure you want to share order for execution with trade desk?',
}) => {
    const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);

    const handleOpenConfirmation = () => {
        setConfirmationDialogOpen(true);
    };

    const handleCloseConfirmation = (event: React.MouseEvent) => {
        event.stopPropagation();
        setConfirmationDialogOpen(false);
    };

    const handleConfirmShare = async (event: React.MouseEvent) => {
        event.stopPropagation();
        try {
            await onShare();
        } finally {
            setConfirmationDialogOpen(false);
        }
    };

    return (
        <>
            <button
                className='share-button-primary'
                onClick={handleOpenConfirmation}
                disabled={disabled || hasShared}
                style={{ cursor: 'pointer' }}
            >
                <FaShare className='share-button-primary-icon' />
                Share
            </button>

            <Dialog
                open={confirmationDialogOpen}
                onClose={handleCloseConfirmation}
                aria-labelledby='confirm-dialog-title'
                aria-describedby='confirm-dialog-description'
                style={{ borderRadius: '8px' }}
            >
                <CloseIcon
                    style={{ marginLeft: 'auto', marginRight: '10px', marginTop: '10px' }}
                    onClick={handleCloseConfirmation}
                />
                <div
                    style={{
                        width: '450px',
                        height: '364px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '100px',
                            marginTop: '30px',
                        }}
                    >
                        <GreenOrderIcon />
                    </div>
                    <DialogTitle
                        id='confirm-dialog-title'
                        style={{
                            alignSelf: 'center',
                            fontWeight: '600',
                            fontSize: '20px',
                            paddingBottom: '5px',
                        }}
                    >
                        {dialogTitle}
                    </DialogTitle>
                    <DialogContent
                        style={{
                            maxHeight: '90px',
                            overflow: 'hidden',
                        }}
                    >
                        <DialogContentText
                            id='confirm-dialog-description'
                            style={{
                                paddingLeft: '32px',
                                textAlignLast: 'center',
                                paddingBottom: '30px',
                                fontSize: '18px',
                                color: '#09090B66',
                            }}
                        >
                            {dialogDescription}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={handleConfirmShare}
                            style={{
                                width: '93px',
                                height: '40px',
                                background: '#0066A6',
                                color: 'white',
                                borderRadius: '8px',
                                textTransform: 'none',
                            }}
                            disabled={loading}
                        >
                            Share
                        </Button>
                    </DialogActions>
                </div>
            </Dialog>
        </>
    );
};
